import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { sanity } from "../client.js";
import { PortableText } from "@portabletext/react";

const About = () => {
	const [skills, setSkills] = useState(null);
	const [education, setEducation] = useState(null);
	const [certificates, setCertificates] = useState(null);

	useEffect(() => {
		sanity
			.fetch(
				`*[_type == "skillsExperiences"]|order(_createdAt asc){
			title,
			description,
			positionheld,
			dateDuration,
		}`
			)
			.then((data) => setSkills(data))
			.catch(console.error);
		sanity
			.fetch(
				`*[_type == "education"]|order(_createdAt asc){
			school,
			degree,
			dateDuration,
		}`
			)
			.then((data) => setEducation(data))
			.catch(console.error);

		sanity
			.fetch(
				`*[_type == "certificates"]|order(_createdAt asc){
			title,
			platformCollected,
			description,
		}`
			)
			.then((data) => setCertificates(data))
			.catch(console.error);
	}, []);

	return (
		<Wrapper>
			<main>
				<StyledProfile
					data-aos="fade-up"
					data-aos-delay="50"
					data-aos-offset="200"
					data-aos-duration="1000"
					data-aos-easing="ease-in-out"
					data-aos-once="true"
				>
					<h2 className="me-picture">Me.</h2>
					<div>
						<img
							src="./images/profile-picture.png"
							alt=""
							className="profile-pic"
						/>
						<p className="profile-description">
							I am a multidiscipled design professional with
							experience in creating and delivering elegant,
							innovative design solutions that excite consumers
							and grow iconic brands. Skilled in leading multiple
							projects from concept through to completion.
							Hands-on in transforming complex information and
							concepts into attractive, human-centred designs.
						</p>
					</div>
				</StyledProfile>

				<CV
					className="cv"
					data-aos="fade-up"
					data-aos-offset="250"
					data-aos-delay="100"
					data-aos-duration="1200"
					data-aos-easing="ease-in-out"
					data-aos-once="true"
				>
					<section>
						<div className="skills-heading">
							<h2>Skills & Experience</h2>

							<span className="skills-description">
								Design thinking • Product Design • Motion
								Graphics • Design Communication • Creative
								Design • Brand Identity Design • UserExperience
								(UX) • User-centered Design • Visual Design
							</span>
							<img
								src="./images/RoundCube2.png"
								alt=""
								className="skills-cube"
							/>
							<img
								src="./images/cone.png"
								alt=""
								className="skills-cone"
							/>
						</div>
						<div className="cv-container">
							<div className="desk-image">
								<img
									src="./images/user-card.png"
									alt=""
									className="mobile-phone"
								/>
							</div>

							<div
								className="experience-infos"
								data-aos="fade-up"
								data-aos-offset="300"
								data-aos-delay="50"
								data-aos-duration="1200"
								data-aos-easing="ease-in-out"
							>
								{skills &&
									skills.map((skill, index) => (
										<div key={index}>
											<h3>{skill.title}</h3>
											<span className="experience-info-work">
												{skill.positionheld}
											</span>
											<span className="experience-info-date">
												{skill.dateDuration}
											</span>
											<div className="experience-info-description">
												<div>
													<PortableText
														value={
															skill.description
														}
													/>
												</div>
											</div>
										</div>
									))}
							</div>

							<img
								src="./images/RoundCube3.png"
								alt=""
								className="desk-image cube3"
							/>
							<img
								src="./images/Sphere-Blue-Glossy.png"
								alt=""
								className="desk-image blue-ball"
							/>
						</div>
					</section>

					<section>
						<div className="education-heading">
							<h2>Education</h2>

							<img
								src="./images/SuperToroid.png"
								alt=""
								className="small-donut"
							/>
						</div>
						<div className="cv-container">
							<div>
								<img
									src="./images/SuperToroid-2.png"
									alt=""
									className="big-donut desk-image"
								/>
							</div>
							<div
								className="experience-infos"
								data-aos="fade-up"
								data-aos-offset="300"
								data-aos-delay="50"
								data-aos-duration="1200"
								data-aos-easing="ease-in-out"
								data-aos-once="true"
							>
								{education &&
									education.map((education, index) => (
										<div key={index}>
											<h3>{education.school}</h3>
											<span className="experience-info-work">
												{education.degree}
											</span>
											<span className="experience-info-date">
												{education.dateDuration}
											</span>
										</div>
									))}
							</div>
						</div>
					</section>

					<section className="certificate">
						<h2>certificates</h2>
						<div className="cv-container">
							<div>
								<img src="" alt="" />
							</div>
							<div
								className="experience-infos"
								data-aos="fade-up"
								data-aos-offset="300"
								data-aos-delay="50"
								data-aos-duration="1200"
								data-aos-easing="ease-in-out"
								data-aos-once="true"
							>
								{certificates &&
									certificates.map((certificates, index) => (
										<div key={index}>
											<h3>{certificates.title}</h3>
											<span className="experience-info-work">
												{certificates.platformCollected}
											</span>
											<span className="experience-info-date">
												{certificates.description}
											</span>
										</div>
									))}
							</div>
						</div>
						<img src="./images/cube.png" alt="" className="cube" />
					</section>
				</CV>
			</main>
		</Wrapper>
	);
};

export default About;

const Wrapper = styled.div`
	padding: 0 16px;
	overflow: hidden;
	@media (min-width: 550px) {
		padding: 0 32px;
	}
	@media (min-width: 750px) {
		margin: 0 auto;
		max-width: 850px;
		overflow: revert;
	}

	@media (min-width: 1000px) {
		max-width: 1000px;
	}
`;
const StyledProfile = styled.div`
	margin: 128px 0;

	.profile-pic {
		width: 100%;
		max-width: 500px;
	}

	.profile-description {
		line-height: 1.5;
		margin-top: 16px;
		max-width: 350px;
	}

	.me-picture {
		width: 200px;
		font-size: 6rem;
	}
	@media (min-width: 550px) {
		.profile-pic {
			max-width: 100%;
		}
	}
	@media (min-width: 650px) {
		display: flex;
		border-radius: 8px;
		gap: 32px;
		align-items: flex-start;
		justify-content: space-between;

		.me-picture {
			margin: 32px 0;
		}
	}

	@media (min-width: 1000px) {
		margin: 180px 0;
		.me-picture {
			width: max-content;
			font-size: 8rem;
		}

		.profile-description {
			margin-top: 32px;
			max-width: 500px;
		}
	}
`;

const CV = styled.div`
	.desk-image {
		display: none;

		@media (min-width: 750px) {
			display: block;
		}
	}

	.mobile-phone {
		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(12px);
			}
		}
		& {
			animation: bounce 1.6s infinite alternate;
		}
	}
	section {
		margin: 72px 0;
	}
	.cv-container {
		position: relative;
		display: grid;

		@media (min-width: 750px) {
			grid-template-columns: 35% 65%;
		}
	}

	.experience-infos {
		h3 {
			margin-top: 32px;
		}
		span {
			display: block;
			font-size: 0.8rem;
			margin: 4px 0;
		}

		@media (min-width: 750px) {
			border-left: 2px solid grey;
			padding-left: 32px;
		}

		li {
			margin: 8px 0;
		}
	}

	.skills-description {
		display: inline-block;
		padding: 0 16px;
		text-align: center;
		margin: 16px 0;
	}
	.experience-info-description {
		margin-top: 16px;
		ul {
			list-style-type: none;
		}

		li:before {
			content: "- ";
		}
		@media (min-width: 750px) {
		}
	}

	.skills-heading {
		position: relative;
		& > img {
			width: 100px;
			position: absolute;
			z-index: -1;
		}

		.skills-cone {
			bottom: -80px;
			right: 30px;

			@keyframes bounce {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(12px);
				}
			}
			& {
				animation: bounce 1.4s infinite alternate;
			}
		}

		.skills-cube {
			top: -80px;
			left: 40px;

			@keyframes bounce {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(16px);
				}
			}
			& {
				animation: bounce 1.6s infinite alternate;
			}
		}
	}

	.cube3 {
		position: absolute;
		bottom: 240px;
		left: 130px;
		width: 150px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-12px);
			}
		}
		& {
			animation: bounce 1.4s infinite alternate;
		}
	}

	.blue-ball {
		position: absolute;
		bottom: 1200px;
		right: -75px;
		width: 100px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(-12px);
			}
		}
		& {
			animation: bounce 1.4s infinite alternate;
		}
	}

	.education-heading {
		position: relative;
		width: max-content;
		.small-donut {
			width: 100px;
			position: absolute;
			right: -90px;
			top: -70px;
			z-index: -1;

			@keyframes bounce {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(-8px);
				}
			}
			& {
				animation: bounce 1.4s infinite alternate;
			}
		}
	}
	.big-donut {
		width: 150px;

		@keyframes bounce {
			0% {
				transform: translateY(0);
			}
			100% {
				transform: translateY(16px);
			}
		}
		& {
			animation: bounce 1.5s infinite alternate;
		}
	}

	.certificate {
		position: relative;
		margin-bottom: 80px;
		& .cube {
			position: absolute;
			bottom: -100px;
			left: 40%;
			width: 100px;

			@keyframes bounce {
				0% {
					transform: translateY(0);
				}
				100% {
					transform: translateY(12px);
				}
			}
			& {
				animation: bounce 1.4s infinite alternate;
			}
		}
	}
`;
